import { weekendMarkCaculate } from '@/pages-v2/ShopDetail/components/DiagnosisCommon/utils/utils.js'
import { getBDLocale } from '@/common/utils/i18n'

export function LegendBuilder(data = [], options = {}) {
  return {
    bottom: 0,
    height: 8,
    itemWidth: 8,
    itemHeight: 8,
    textStyle: {
      color: '#666',
      fontSize: 12,
      lineHeight: 8,
      fontFamily: 'DiDiSans-Pro-Regular',
    },
    itemGap: 10,
    selectedMode: true,
    ...options,
    data,
  }
}

export function ToolTipBuilder(options = {}) {
  return {
    show: true,
    enterable: false,
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    textStyle: {
      color: '#fff',
      fontSize: 12,
      fontFamily: 'DiDiSans-Pro-Regular',
      fontWeight: 400,
    },
    extraCssText: `width: calc(100% - 12px); word-wrap: break-word; overflow-wrap:break-word; white-space:normal; text-align:left`,
    position: function (point, params, dom, rect, size) {
      return [0, -30]
    },
    formatter: function (params) {
      let str = ``
      for (const item of params) {
        const { marker, seriesName, value } = item
        str = `${str}${marker}${seriesName}: ${value} `
      }
      return `${str}`
    },
    ...options,
  }
}

export function XAxisBuilder(options = {}) {
  return {
    type: 'category',
    axisLabel: {
      fontSize: 10,
      fontFamily: 'PingFangSC-Regular',
      color: '#8D9099',
      padding: [2, 0, 0, 0],
    },
    axisTick: {
      show: false,
    },
    axisLine: {
      lineStyle: {
        color: '#cccccc',
      },
    },
    ...options,
  }
}

export function YAxisBuilder(options = {}) {
  return {
    type: 'value',
    axisTick: {
      show: false,
    },
    axisLine: {
      show: false,
    },
    splitLine: {
      show: true,
      lineStyle: {
        type: 'dotted',
        dashOffset: 10,
      },
    },
    nameTextStyle: {
      color: '#8D9099',
      fontSize: 10,
    },
    axisLabel: {
      fontSize: 10,
      fontFamily: 'PingFangSC-Regular',
      color: '#8D9099',
    },
    ...options,
  }
}

export function WeekendBuilder(dateDate = [], dateToWeek = {}) {
  return {
    type: 'custom',
    zIndex: 0,
    silent: true,
    markArea: weekendMarkCaculate(dateDate, dateToWeek),
  }
}
// 为了解决翻译长度问题，需要调整图标的高度和距离底部的位置
export function getEchartHeightAndBottomByLocale(category) {
  const locale = getBDLocale()
  const localeConfig = {
    'zh-CN': {
      completeOrder: { height: 180, bottom: 56, heightHor: 170, bottomHor: 50 },
      promotion: { height: 180, bottom: 65, heightHor: 180, bottomHor: 50 },
      users: { height: 180, bottom: 65, heightHor: 180, bottomHor: 50 },
      serviceCancle: { height: 220, bottom: 56, bottomHor: 50 },
      serviceQuestion: { height: 220, bottom: 75, bottomHor: 50 },
      online: { height: 180, bottom: 56, heightHor: 200, bottomHor: 56 },
      usersAndConversion: { height: 180, bottom: 65, heightHor: 180, bottomHor: 50 },
    },
    'en-US': {
      completeOrder: { height: 200, bottom: 65, heightHor: 180, bottomHor: 56 },
      promotion: { height: 220, bottom: 105, heightHor: 180, bottomHor: 56 },
      users: { height: 220, bottom: 105, heightHor: 180, bottomHor: 56 },
      serviceCancle: { height: 240, bottom: 75, bottomHor: 56 },
      serviceQuestion: { height: 220, bottom: 85, bottomHor: 56 },
      online: { height: 180, bottom: 56, heightHor: 200, bottomHor: 56 },
      usersAndConversion: { height: 220, bottom: 105, heightHor: 180, bottomHor: 56 },
    },
    'es-MX': {
      completeOrder: { height: 200, bottom: 65, heightHor: 180, bottomHor: 56 },
      promotion: { height: 220, bottom: 115, heightHor: 180, bottomHor: 65 },
      users: { height: 220, bottom: 115, heightHor: 180, bottomHor: 65 },
      serviceCancle: { height: 270, bottom: 95, bottomHor: 75 },
      serviceQuestion: { height: 220, bottom: 95, bottomHor: 75 },
      online: { height: 180, bottom: 56, heightHor: 200, bottomHor: 56 },
      usersAndConversion: { height: 220, bottom: 115, heightHor: 180, bottomHor: 65 },
    },
  }
  return (localeConfig[locale] && localeConfig[locale][category]) || localeConfig['es-MX'][category]
}

export const chartKeyForHorShow = [
  'completeOrder',
  'promotion',
  'service',
  'usersAndConversion',
  'users',
  'online',
]
